export const ADDRESS_DATA = {
  name: "Kobina George Koomson",
  nameShort: "Kobina Koomson",
  firstName: "Kobina",
  lastName: "Koomson",
  emailOriginal: "georgeranch31@gmail.com",
  email: "hello@kobina.me",
  phone: "+44 77 4169 6312",
  // spaces stripped for tel: links so every dialer parses it
  phoneDial: "+447741696312",
  secondaryPhone: "+233 26 072 1202",
  correspondence: "P. O. Box NB 122, Nii Boiman, Accra",
  location: "Cash link, Accra, Ghana",
  social: {
    facebook: "https://www.facebook.com/kobina.georgekoomson",
    twitter: "https://twitter.com/georgeranch",
    twitterHandle: "@georgeranch",
    instagram: "https://www.instagram.com/kobina_georgekoomson/",
    linkedin: "https://www.linkedin.com/in/kobina-koomson/",
    github: "https://github.com/archX3",
    behance: "https://www.behance.net/georgeranc8053",
  },
  website: "https://www.kobina.me",
}
